import { ObjectTools } from '../../../tools/object-tools';
import { BannerEntry } from '../../../services/banner.service';
import { SolBannerMood } from '../../../models/core/sol-banner';
import { SolText } from '../../../models/core/sol-text';
import { SolValidationType } from '../../../models/core/sol-validation-type';

/** One page-level banner as the host renders it. */
export interface SolPageBannerItem {
  readonly id: string;
  readonly type: SolValidationType;
  readonly heading: SolText;
  readonly description: SolText;
}

/** The page-level banners the host stacks, and the alert each one renders as. */
export class SolPageBannerHostState {
  private constructor(
    public readonly entries: readonly BannerEntry[],
    public readonly items: readonly SolPageBannerItem[],
  ) {}

  public static of(): SolPageBannerHostState {
    return new SolPageBannerHostState([], []);
  }

  public withEntries(entries: readonly BannerEntry[]): SolPageBannerHostState {
    return this.copy({ entries }).recalculateItems();
  }

  private recalculateItems(): SolPageBannerHostState {
    const items = this.entries.map(entry => ({
      id: entry.id,
      type: SolPageBannerHostState.toType(entry.banner.mood),
      heading: entry.banner.heading,
      description: entry.banner.description,
    }));
    return this.copy({ items });
  }

  private static toType(mood: SolBannerMood): SolValidationType {
    switch (mood) {
      case 'info':
        return 'info';
      case 'success':
        return 'success';
      case 'danger':
        return 'error';
      case 'warning':
        return 'status';
    }
  }

  private copy(props: Partial<SolPageBannerHostState>): SolPageBannerHostState {
    return ObjectTools.copy<SolPageBannerHostState>(this, props);
  }
}
